/**
 * 部屋ソート
 * @param {array} items          sort items (jQuery Array Object)
 * @param {string} dataName      data name
 * @param {mixed} sign           sort sign
 * @param {string} sorter        sorter name
 */
function roomSort(items, dataName, sign, sorter) {
  var layout_names = {
    "SLDK": 5,
    "LDK" : 4,
    "DK"  : 3,
    "K"   : 2,
    "R"   : 1
  };
  var dataNames = dataName.split(",");
  var sorters = {
    "number": function(a, b) {
      var $a = $(a);
      var $b = $(b);
      if ($a.data(dataName) === $b.data(dataName)) {
        return (+$a.data("room_id") < +$b.data("room_id") ? -1 : 1) * sign;
      }
      return (+$a.data(dataName) < +$b.data(dataName) ? -1 : 1) * sign;
    },
    "string": function(a, b) {
      var $a = $(a);
      var $b = $(b);
      if ($a.data(dataName) !== $b.data(dataName)) {
        return ($a.data(dataName) < $b.data(dataName) ? -1 : 1) * sign;
      }
      return (+$a.data("room_id") < +$b.data("room_id") ? -1 : 1) * sign;
    },
    "plan": function(a, b) {
      var $a = $(a);
      var $b = $(b);
      if ($a.data(dataNames[0]) !== $b.data(dataNames[0])) {
        return (+$a.data(dataNames[0]) < +$b.data(dataNames[0]) ? -1 : 1) * sign;
      } else if ($a.data(dataNames[1]) !== $b.data(dataNames[1])) {
        return (layout_names[$a.data(dataNames[1])] < layout_names[$b.data(dataNames[1])] ? -1 : 1) * sign;
      }
      return (+$a.data("room_id") < +$b.data("room_id") ? -1 : 1) * sign;
    }
  };
  items.sort(sorters[sorter]);
}

/**
 * 部屋ソート（pc）
 * @param {mixed} container      selector or dom object or jquery object
 * @param {string} dataName      data name
 * @param {mixed} sort           "asc", "desc", true, false
 * @param {string} sorter        sorter name
 * @param {string} itemsSelector sort items selector
 */
function roomSort_pc(container, dataName, sort, sorter, itemsSelector) {
  var more = $(container).nextAll(".more,.more_on");
  var more_is_on = more.hasClass("more_on");
  var subRoomCount = +more.find("p").text().match(/\d+/);
  var subListClassName = "subList"+(more_is_on?"_on":"");
  container = ($(container).children("tbody").length > 0) ? $(container).children("tbody") : $(container);
  var items = container.children(itemsSelector);
  var sign = (sort == null || (sort.toLowerCase && sort.toLowerCase() === "asc") || sort === true) ? 1 : -1;

  roomSort(items, dataName, sign, sorter);

  var i=0;
  items.each(function() {
    $(this).removeClass(subListClassName);
    if (++i > items.length - subRoomCount) {
      $(this).addClass(subListClassName);
    }
    container.append(this);
  });
}

/**
 * 部屋ソート(sp)
 * @param {mixed} container      selector or dom object or jquery object
 * @param {string} dataName      data name
 * @param {mixed} sort           "asc", "desc", true, false
 * @param {string} sorter        sorter name
 * @param {string} itemsSelector sort items selector
 */
function roomSort_sp(container, dataName, sort, sorter, itemsSelector) {
  var more = $(container).nextAll(".roomMore");
  var more_is_on = more.hasClass("open");
  var subRoomCount = +more.find("span").text().match(/\d+/);
  var nohideClassName = "nohide";
  container = ($(container).children("tbody").length > 0) ? $(container).children("tbody") : $(container);
  var items = container.children(itemsSelector);
  var sign = (sort == null || (sort.toLowerCase && sort.toLowerCase() === "asc") || sort === true) ? 1 : -1;

  roomSort(items, dataName, sign, sorter);

  var i=0;
  items.each(function() {
    $(this).removeClass(nohideClassName).show();
    if (++i <= items.length - subRoomCount) {
      $(this).addClass(nohideClassName);
    } else {
      if (!more_is_on) $(this).hide();
    }
    container.append(this);
  });
}

function roomSortableHeader_clickHandler() {
  var self = $(this);
  var table = self.closest("table");
  var data = self.data();
  var sortSwitch = function(a) {
    switch(a) {
      case "asc": return "desc";
      case "desc": return "asc";
      default: return data.defaultSort||"asc";
    }
  };
  var newSort = sortSwitch(data.sort);
  table.find("th[data-sort]:not([data-field='"+data.field+"'])").data("sort", "").removeClass("asc desc");
  self.data("sort", newSort).removeClass("asc desc").addClass(newSort);
  table.find("input[name=room_sort_field]").val(data.field);
  table.find("input[name=room_sort]").val(newSort);

  roomSort_pc(table, data.field, newSort, data.sorter, ":not(:first-child)");
}

function roomSortSync(table) {
  table = $(table);
  var field = table.find("input[name=room_sort_field]").val();
  var sort = table.find("input[name=room_sort]").val();
  if (field) {
    table.find("th[data-sort]:not([data-field='"+field+"'])").data("sort", "").removeClass("asc desc");
    var sorter = table.find("th[data-field='"+field+"']").data("sort", sort).removeClass("asc desc").addClass(sort).data("sorter");
    roomSort_pc(table, field, sort, sorter, ":not(:first-child)");
  }
}

/**
 * 部屋ソートPC セレクトボックスchangeイベントハンドラ
 */
function roomSortPc_selectChangeHandler() {
  // ソート切替切替要素
  var self = $(this);
  // ソートコンテナ（リスト親要素）
  var container = self.closest(".roomList").find(".roomContainer");
  // ソートなし判定
  if (!self.val()) return;
  // ソート設定取得
  var vars = self.val().split(":");
  var field = vars[0];
  var sort = vars[1];
  var sorter = vars[2];
  // リスト要素セレクタ
  var itemsSelector = ".room-row";
  // ソート実行
  roomSort_sp(container, field, sort, sorter, itemsSelector);
}

/**
 * 部屋ソートSP セレクトボックスchangeイベントハンドラ
 */
function roomSortSp_selectChangeHandler() {
  // ソート切替切替要素
  var self = $(this);
  // ソートコンテナ（リスト親要素）
  var container = self.parent().find(".roomContainer");
  // ソートなし判定
  if (!self.val()) return;
  // ソート設定取得
  var vars = self.val().split(":");
  var field = vars[0];
  var sort = vars[1];
  var sorter = vars[2];
  // リスト要素セレクタ
  var itemsSelector = ".roomList";
  // ソート実行
  roomSort_sp(container, field, sort, sorter, itemsSelector);
}
